<template>
  <v-container>
    <v-layout id="profile-layout" row wrap>
      <v-flex xs12>
        <span style="font-size:45px;font-weight:bold;color:white;">
          Perfil
        </span>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-card
          class="strategio-card-container py-2"
        >
          <v-card-text style="padding-left:32px !important;padding-right:32px !important;">
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 lg6 xl6 class="px-4">
                <img width="60px" height="55px" :src="require('@/assets/profile-icons/user.png')" alt="">
                <v-text-field
                  id="txtUserName"
                  name="txtUserName"
                  label="Nombre"
                  v-model="userData.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 xl6 class="px-4">
                <img width="60px" height="55px" :src="require('@/assets/profile-icons/position.png')" alt="">
                <v-text-field
                  id="txtDescription"
                  name="txtDescription"
                  label="Cargo o descripción"
                  v-model="userData.description"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 xl6 class="px-4">
                <img width="60px" height="55px" :src="require('@/assets/profile-icons/email.png')" alt="">
                <v-text-field
                  id="txtMail"
                  name="txtMail"
                  label="Correo o código de usuario"
                  v-model="userData.mail"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 xl6 class="px-4">
                <img width="60px" height="55px" :src="require('@/assets/profile-icons/phone.png')" alt="">
                <v-text-field
                  id="txtPhone"
                  name="txtPhone"
                  label="Teléfono"
                  v-model="userData.phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 x12 class="px-4">
                <!-- <img width="60px" height="55px" :src="require('@/assets/profile-icons/user.png')" alt=""> -->
                <v-icon
                  style="color:#00B9DE;font-size:60px;"
                >link</v-icon>
                <v-text-field
                  id="txtProfileImageUrl"
                  name="txtProfileImageUrl"
                  label="URL de la imagen de perfil"
                  v-model="userData.profileImageUrl"
                ></v-text-field>
              </v-flex>

              <v-flex v-show="!this.isNewUser" xs12 sm12 md12 lg12 xl12 class="pr-3">
                <v-card-actions class="white">
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed round
                    class="strategio-card-button"
                    color="success"
                    @click="updateUserProfile()"
                  >Actualizar perfil</v-btn>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout id="security-layout" row wrap class="mt-3">
      <v-flex xs12>
        <span style="font-size:45px;font-weight:bold;color:white;">
          Seguridad
        </span>
      </v-flex>
      <v-flex>
        <v-card
          class="strategio-card-container py-2"
        >
          <v-card-text style="padding-left:32px !important;padding-right:32px !important;">
            <v-layout row wrap>
              <!-- <v-flex class="strategio-my-account-sub-division" xs12 sm12 md12 lg12 xl12> -->
                <!-- Seguridad <br /> -->
              <v-subheader class="flex xs12">La contraseña debe contener al menos 6 caracteres</v-subheader>
              <!-- </v-flex> -->
              <v-flex xs12 sm12 md6 lg6 xl6 class="px-4">
                <img width="60px" height="55px" :src="require('@/assets/profile-icons/password.png')" alt="">
                <v-text-field
                  id="txtPassword"
                  name="txtPassword"
                  label="Nueva contraseña"
                  v-model="password"
                  :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (hidePassword = !hidePassword)"
                  :type="hidePassword ? 'password' : 'text'"
                  :rules="[(v) => v.length >= 6 || 'Minimo 6 characters']"
                  :counter="6"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 xl6 class="px-4">
                <img width="60px" height="55px" :src="require('@/assets/profile-icons/password.png')" alt="">
                <v-text-field
                  id="txtConfirmPassword"
                  name="txtConfirmPassword"
                  label="Confirmar contraseña"
                  v-model="confirmPassword"
                  :rules="[validatePassword()]"
                  :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (hidePassword = !hidePassword)"
                  :type="hidePassword ? 'password' : 'text'"
                ></v-text-field>
              </v-flex>
              <v-flex v-show="!this.isNewUser" xs12 sm12 md12 lg12 xl12>
                <v-card-actions class="white">
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed round
                    class="strategio-card-button"
                    color="error"
                    :disabled="!canChangePassword || password === ''"
                    @click="updateUserPassword()"
                  >
                    Cambiar contraseña
                  </v-btn>
                </v-card-actions>
              </v-flex>
            </v-layout>
            
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
    <v-layout id="access-layout" v-if="!isMyAccount || isNewUser" row wrap class="mt-3">
      <v-flex xs12>
        <span style="font-size:45px;font-weight:bold;color:white;">
          Acceso
        </span>
      </v-flex>
      <v-flex>
        <v-card
          class="strategio-card-container py-2"
        >
          <v-card-text style="padding-left:32px !important;padding-right:32px !important;">
            <v-layout row wrap>
              <v-flex v-if="!isMyAccount" xs12 sm12 md12 lg12 xl12>
                <!-- <v-flex class="strategio-my-account-sub-division" xs12 sm12 md12 lg12 xl12>
                  Acceso
                </v-flex> -->
                <v-flex xs12 sm12 md12 lg12 xl12>
                  <v-card-actions>
                    <v-checkbox
                      style="color:#01C0D1 !important"
                      label="Habilitado"
                      v-model="userData.isEnabled"
                    ></v-checkbox>
                    <v-select
                      bottom
                      item-text="name"
                      item-value="type"
                      :items="items"
                      :hint="hintMessage"
                      persistent-hint
                      label="Tipo de usuario"
                      v-model="userData.userType"
                    >
                      <v-tooltip class="layout column" top slot="item" slot-scope="data">
                        <v-flex slot="activator">
                          {{ data.item.name }}
                        </v-flex>
                        <v-flex>{{ data.item.description }}</v-flex>
                      </v-tooltip>
                    </v-select>
                  </v-card-actions>
                  
                </v-flex>

                <v-flex v-show="!this.isNewUser" xs12 sm12 md12 lg12 xl12>                  
                  <v-card-actions class="white">
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed round
                      class="strategio-card-button"
                      color="success"
                      @click="updateUserAccessLevel()"
                    >
                      Actualizar niveles de acceso
                    </v-btn>
                  </v-card-actions>
                </v-flex>

                <v-flex v-if="userData.userType === 'NORMAL'" class="strategio-my-account-sub-division" xs12 sm12 md12 lg12 xl12>
                  Permisos <br v-show="loadedAssignedReports" />
                  <v-subheader v-show="loadedAssignedReports">Se han asignado &nbsp; <b>{{assignedReports.length}}</b>&nbsp; items a este usuario </v-subheader>
                </v-flex>
                <v-flex v-if="userData.userType === 'NORMAL'" xs12 sm12 md12 lg12 xl12>
                  <show-reports-permisions-dialog 
                    :user-id="userData.userID" 
                    :items-data="itemsTree"
                    :is-new-user="this.isNewUser"
                  ></show-reports-permisions-dialog>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex v-show="this.isNewUser" xs12 sm12 md12 lg12 xl12>
                <v-card-actions class="white layout justify-center">
                  <!-- <v-spacer></v-spacer> -->
                  <v-btn
                      depressed round
                      class="strategio-card-button"
                      color="success"
                    :disabled="!canChangePassword || password === ''"
                    @click="createUser()"
                  >
                    Crear usuario
                  </v-btn>
                </v-card-actions>
              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <custom-snack-bar></custom-snack-bar>
    <are-you-sure-dialog></are-you-sure-dialog>
  </v-container>
</template>

<script>
import {find} from 'lodash'

import eventBus from '../../utils/eventBus'
import introBus from '../../utils/introBus'

import userStorage from '../../storage/userStorage'
import adminStorage from '../../storage/adminStorage'
import ShowReportsPermisionsDialog from '../dialogs/show-reports-permisions-dialog.vue'
import AreYouSureDialog from '../dialogs/are-you-sure-dialog.vue'

import CustomSnackBar from '../snackbars/custom-snack-bar.vue'

export default {
  name: 'user-form',
  created () {
    eventBus.$off('show-updated-Reports')
    eventBus.$on('show-updated-Reports', (data) => {
      this.loadedAssignedReports = true
      this.assignedReports = data
    })
  },
  mounted () {
    // emits to: /components/header-bar/strategio-app-bar.vue
    eventBus.$emit('enable-tutorial-button')

    eventBus.$off('start-user-form-tutorial')
    eventBus.$on('start-user-form-tutorial', () => {
      // Existen varias versiones del formulario
      // Preguntar en que ruta nos encontramos
      let intro = introBus.getIntroBus()
      intro.addSteps([
        {
          element: '#profile-layout',
          intro: 'En esta sección uno podrá alterar el perfil del usuario.'
        },
        {
          element: '#security-layout',
          intro: 'Aquí se podrá crear o modificar la contraseña.'
        },
        {
          element: '#access-layout',
          intro: 'Finalmente, en esta sección se puede manipular el nivel de permisos con el que el usuario contará'
        }
      ].filter((obj) => {
        return document.getElementById(obj.element.split('#')[1])
      }))
      intro.start()
    })
  },
  data () {
    return {
      password: '',
      confirmPassword: '',
      hidePassword: true,
      canChangePassword: false,
      showReportsDialog: false,
      items: [
        {
          type: 'NORMAL',
          name: 'Normal',
          description: 'Acceso a perfil, visualizador, favoritos y tutorial'
        },
        {
          type: 'GLOBAL',
          name: 'Global',
          description: 'Acceso NORMAL, más acceso a todos los reportes'
        },
        {
          type: 'SUPERVISOR',
          name: 'Supervisor',
          description: 'Acceso GLOBAL, más herramientas administrativas'
        }
      ],
      assignedReports: [],
      loadedAssignedReports: false,
      snackMessage: '',
      snackbar: false,
      snackItsOk: true,
      isWarning: false,
      snackActionMessage: 'Cerrar',
      snackActionFunction: () => { this.snackbar = false }
    }
  },
  computed: {
    hintMessage () {
      // return find(this.items, (item) => item.type === this.userData.userType).description
      return find(this.items, (item) => item.type === this.userData.userType) ? find(this.items, (item) => item.type === this.userData.userType).description : ''
    }
  },
  methods: {
    openSnackBar (message, itsOk, snackAction) {
      eventBus.$emit('open-custom-snack-bar', {message, itsOk, snackAction})
    },
    validatePassword () {
      this.canChangePassword = (this.password === this.confirmPassword) && this.password.length >= 6
      return this.canChangePassword || 'Los passwords deben ser iguales'
    },
    updateUserProfile () {
      if (this.isMyAccount) {
        userStorage.updateUserInfo({
          data: this.userData,
          onSuccess: () => this.openSnackBar('Perfil actualizado', true),
          onError: () => this.openSnackBar('Error al actualizar perfil', false)
        })
      } else {
        adminStorage.updateUserInfo({
          data: this.userData,
          onSuccess: () => this.openSnackBar('Perfil actualizado', true),
          onError: () => this.openSnackBar('Error al actualizar perfil', false)
        })
      }
    },
    updateUserPassword () {
      if (this.isMyAccount) {
        userStorage.updatePassword({
          newPassword: this.password,
          onSuccess: () => this.openSnackBar('Password cambiado', true),
          onError: () => this.openSnackBar('Error al cambiar de password', false)
        })
      } else {
        adminStorage.updatePassword({
          userID: this.userData.userID,
          newPassword: this.password,
          onSuccess: () => this.openSnackBar('Password cambiado', true),
          onError: () => this.openSnackBar('Error al cambiar de password', false)
        })
      }
    },
    updateUserAccessLevel () {
      adminStorage.updateAccessLevel({
        userID: this.userData.userID,
        newUserType: this.userData.userType,
        isEnabled: this.userData.isEnabled,
        onSuccess: () => this.openSnackBar('Nivel de acceso actualizado', true),
        onError: () => this.openSnackBar('Ha habido un error al actualizar el nivel de acceso', false)
      })
    },
    createUser () {
      adminStorage.createUser({
        userData: {...this.userData, password: this.password, permissions: this.assignedReports},
        onSuccess: (response) => {
          this.password = ''
          this.confirmPassword = ''
          this.canChangePassword = false
          // eslint-disable-next-line
          if (response.data.status == 1 && !['SUPERVISOR', 'GLOBAL'].includes(this.userData.userType)) {
            this.openSnackBar('El usuario ha sido creado pero no puede ver reportes', 'warning', {
              title: 'Ver usuario',
              action: () => {
                this.$router.push(`/user/admin/${response.data.userID}`)
              }
            })
          } else {
            this.openSnackBar('El usuario ha sido creado', true, {
              title: 'Ver usuario',
              action: () => {
                this.$router.push(`/user/admin/${response.data.userID}`)
              }
            })
          }
        },
        onError: (error) => {
          if (error.response && error.response.data && error.response.data.code === 'ER_DUP_ENTRY') {
            this.password = ''
            this.confirmPassword = ''
            this.canChangePassword = false
            this.openSnackBar('El codigo o email del usuario es duplicado', false)
          } else {
            this.openSnackBar('Ha habido un error creando el usuario', false)
          }
        }
      })
    },
    goBack () {
      if (this.isNewUser) {
        eventBus.$emit('open-are-you-sure-dialog', {
          title: '¿Seguro que desea salir?',
          message: 'Los datos ingresados no se guardaran',
          onOk: () => {
            this.$router.push(this.parentRoute)
          }
        })
      } else {
        this.$router.push(this.parentRoute)
      }
    }
  },
  props: {
    userData: {
      type: Object,
      default () {
        return {}
      }
    },
    isMyAccount: {
      type: Boolean,
      default () {
        return false
      }
    },
    itemsTree: {
      type: Array,
      default () {
        return []
      }
    },
    parentRoute: String,
    backButtonText: String,
    isNewUser: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  components: {
    ShowReportsPermisionsDialog,
    CustomSnackBar,
    AreYouSureDialog
  }
}
</script>
<style>
.strategio-my-account-sub-division {
  font-size: 24px;
  font-weight: 300;
  margin-top: 24px;
  margin-bottom: 8px;
}
.strategio-user-form-return-button {
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/users/user-form.vue